module.exports = __webpack_public_path__ + "static/media/riskOnePoint.f8a65892.mp3";